import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, User, Building2, FileText } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";

const Groupe = ({ titre, items, rendu }) => items.length > 0 && (
  <div className="mb-3"><p className="at-label px-2 mb-1">{titre}</p>{items.map(rendu)}</div>
);

export const RechercheGlobale = ({ ouvert, setOuvert }) => {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [res, setRes] = useState({ contacts: [], organisations: [], fiches: [] });
  useEffect(() => {
    if (!ouvert) { setQ(""); return; }
    const t = setTimeout(() => api.get("/recherche", { params: { q } }).then((r) => setRes(r.data)), 200);
    return () => clearTimeout(t);
  }, [q, ouvert]);
  const aller = (url) => { setOuvert(false); navigate(url); };
  const Ligne = ({ icone: Icone, titre, sous, url, testId, couleur }) => (
    <button type="button" onClick={() => aller(url)} className="w-full flex items-center gap-3 px-2 min-h-[48px] rounded-xl text-left hover:bg-[var(--surface-2)]" data-testid={testId}>
      <Icone size={16} style={{ color: couleur || "var(--muted)" }} className="shrink-0" />
      <span className="min-w-0"><span className="block font-semibold truncate">{titre}</span><span className="block text-xs at-muted truncate">{sous}</span></span>
    </button>
  );
  const vide = q.length >= 2 && !res.contacts.length && !res.fiches.length && !res.organisations.length;
  return (
    <Dialog open={ouvert} onOpenChange={setOuvert}>
      <DialogContent className="at-popover max-w-[calc(100vw-24px)] sm:max-w-xl top-[12%] translate-y-0 p-3" data-testid="global-search-dialog">
        <DialogTitle className="sr-only">Recherche globale</DialogTitle>
        <div className="relative mb-3 mr-10">
          <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 at-muted" />
          <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nom, téléphone, organisation, fiche… (Ctrl+K)" className="at-input !pl-11" data-testid="global-search-input" />
        </div>
        <div className="max-h-[60vh] overflow-y-auto">
          <Groupe titre="Fiches" items={res.fiches} rendu={(f) => <Ligne key={f.id} icone={FileText} couleur={f.temperature} titre={f.nom} sous={`${f.operation} · ${f.etape_label}`} url={`/fiches/${f.id}`} testId={`search-fiche-${f.id}`} />} />
          <Groupe titre="Contacts" items={res.contacts} rendu={(c) => <Ligne key={c.id} icone={User} titre={c.affichage} sous={`${c.telephone} ${c.ville}`} url={`/contacts/${c.id}`} testId={`search-contact-${c.id}`} />} />
          <Groupe titre="Organisations" items={res.organisations} rendu={(o) => <Ligne key={o.id} icone={Building2} titre={o.nom} sous={o.ville} url={`/fiches?recherche=${encodeURIComponent(o.nom)}`} testId={`search-org-${o.id}`} />} />
          {vide && <p className="at-muted text-sm p-3" data-testid="global-search-empty">Aucun résultat.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
